import './style.css'

const Phrase = () => {
  return (
    <h1 className='phrase__title'>Explore nosso <br /> mundo...</h1>
  )
}

export default Phrase;